import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FaChevronLeft } from 'react-icons/fa'
import {
  Button,
  FormGroup,
  Col,
  FormControl,
  Row
} from 'react-bootstrap';

import validate from './validate';
import submit from './submit';
import messages from '../../../../locale/messages';

import s from './ForgotPasswordForm.css';
import bt from '../../../../components/restaurantCommon.css';

class ForgotPasswordForm extends Component {

  static propTypes = {
    openLoginModal: PropTypes.func.isRequired,
  };

  renderFormControl = ({ input, label, type, meta: { touched, error }, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl {...input} placeholder={label} type={type} className={className} />
        {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
      </div>
    );
  }

  render() {
    const { handleSubmit, submitting, dispatch } = this.props;
    const { formatMessage } = this.props.intl;
    const { openLoginModal } = this.props;
    return (
      <div className={s.container}>
        <form onSubmit={handleSubmit(submit)}>
          <FormGroup className={s.formGroup}>
            <p><FormattedMessage {...messages.forgotPasswordInfo} /></p>
          </FormGroup>
          <div className={s.forgetEmail}>
            <FormattedMessage {...messages.email} />
          </div>
          <FormGroup className={s.formGroup}>

            <Field name="email" label={formatMessage(messages.email)}
              component={this.renderFormControl} placeholder={'Email Address'}
              className={cx(bt.formControlInputRestaurant, s.meassageicon, 'meassageiconRTL')}
            />
          </FormGroup>
          <div className={cx(s.formGroup, s.formSection)}>
            <Row className={s.mobileColumn}>
              <Col xs={12} sm={7} md={7} lg={7} className={cx(s.noPadding, s.textAlignLeft, s.displayTable, s.mobileFlex)}>
                <span className={cx(s.displayTableCell, s.leftArrow, 'leftArrowPasswordRTL')}><FaChevronLeft className={s.leftICon} /></span>
                <a href="#" onClick={openLoginModal} className={cx(s.modalCaptionLink, s.modalCaptionLinkLarge, s.displayTableCell, 'textAlignRightRTL')}>
                  <FormattedMessage {...messages.backToLogin} />
                </a>
              </Col>
              <Col xs={12} sm={5} md={5} lg={5} className={cx(s.noPadding, s.textAlignRight, s.textCenterMobile, 'textAlignLeftRTL')}>
                <Button
                  className={cx(bt.btnPrimary)}
                  type="submit"
                  disabled={submitting}
                >
                  <FormattedMessage {...messages.sendLink} />
                </Button>
              </Col>
            </Row>
          </div>
        </form>
      </div>
    )
  }

}

ForgotPasswordForm = reduxForm({
  form: 'ForgotPasswordForm', // a unique name for this form
  validate,
  destroyOnUnmount: true
})(ForgotPasswordForm);

export default withStyles(s, bt)(injectIntl((ForgotPasswordForm)));